export const LogoMark = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="jtk-jg" x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
        <stop stopColor="#101D42" />
        <stop offset="1" stopColor="#0A1128" />
      </linearGradient>
    </defs>
    <rect width="48" height="48" rx="12" fill="url(#jtk-jg)" />
    <path
      d="M14 12c4.2 2.1 6.8 5.6 7.4 10.2"
      stroke="#06B6D4"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.9"
    />
    <path
      d="M36 17c-2.1 3.1-3.5 6.8-3.9 11"
      stroke="#2563EB"
      strokeWidth="1.6"
      strokeLinecap="round"
      opacity="0.9"
    />
    <path
      d="M30 10v17.5c0 6.1-3.7 10-9.3 10-4.1 0-7.3-2.2-8.8-6"
      stroke="#F8FAFC"
      strokeWidth="3.6"
      strokeLinecap="round"
    />
    <circle cx="30" cy="10" r="2.5" fill="#06B6D4" />
    <circle cx="12" cy="31.5" r="2" fill="#2563EB" />
    <circle cx="14" cy="12" r="1.8" fill="#06B6D4" />
    <circle cx="36" cy="17" r="1.8" fill="#2563EB" />
  </svg>
);

export const Logo = ({ dark = true }) => (
  <span className="flex items-center gap-3">
    <LogoMark size={38} />
    <span className="flex flex-col leading-none">
      <span
        className={`font-heading text-lg font-extrabold tracking-[0.18em] ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        JAYTRIKA
      </span>
      <span className="mt-1 hidden text-[9px] font-medium uppercase tracking-[0.28em] text-slate-400 sm:block">
        Telecom Infrastructure
      </span>
    </span>
  </span>
);
